import * as Blockly from 'blockly/core'

class SvgIcon extends Blockly.icons.Icon {
  getSize() {
    // "The size is in arbitrary "workspace units" (which don't change as the workspace changes scale)."
    return new Blockly.utils.Size(24, 24)
  }

  getWeight() {
    // "Icons with more positive weights are rendered after icons with less positive weights."
    return 10
  }

  initView(pointerdownListener: (e: PointerEvent) => void) {
    if (this.svgRoot) return
    super.initView(pointerdownListener)
    this.renderIcon()
  }

  renderIcon() {
    // No-op.
  }
}

export class TurnLeft extends SvgIcon {
  static iconType = 'turn_left_icon'

  getType() {
    return new Blockly.icons.IconType(TurnLeft.iconType)
  }

  renderIcon() {
    Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.PATH,
      {
        d: 'M446.025,92.206c-40.762-42.394-97.487-69.642-160.383-72.182c-15.791-0.638-29.114,11.648-29.752,27.433c-0.638,15.791,11.648,29.114,27.426,29.76c47.715,1.943,90.45,22.481,121.479,54.681c30.987,32.235,49.956,75.765,49.971,124.011c-0.015,49.481-19.977,94.011-52.383,126.474c-32.462,32.413-76.999,52.368-126.472,52.382c-49.474-0.015-94.025-19.97-126.474-52.382c-32.405-32.463-52.368-76.992-52.382-126.474c0-3.483,0.106-6.938,0.302-10.364l34.091,16.827c3.702,1.824,8.002,1.852,11.35,0.086c3.362-1.788,5.349-5.137,5.264-8.896l-3.362-149.834c-0.114-4.285-2.88-8.357-7.094-10.464c-4.242-2.071-9.166-1.809-12.613,0.738L4.008,182.45c-3.05,2.221-4.498,5.831-3.86,9.577c0.61,3.759,3.249,7.143,6.966,8.974l35.722,17.629c-1.937,12.166-3.018,24.602-3.018,37.279c-0.014,65.102,26.475,124.31,69.153,166.944C151.607,465.525,210.8,492.013,275.91,492c65.095,0.014,124.302-26.475,166.937-69.146c42.678-42.635,69.167-101.842,69.154-166.944C512.014,192.446,486.844,134.565,446.025,92.206z',
        fill: '#fff',
        transform: 'translate(6, 3) scale(0.046875)',
      },
      this.svgRoot,
    )
  }
}

export class TurnRight extends SvgIcon {
  static iconType = 'turn_right_icon'

  getType() {
    return new Blockly.icons.IconType(TurnRight.iconType)
  }

  renderIcon() {
    Blockly.utils.dom.createSvgElement(
      Blockly.utils.Svg.PATH,
      {
        d: 'M65.98,72.21C106.74,29.81,163.46,2.56,226.36.02c15.79-.64,29.11,11.65,29.75,27.43.64,15.79-11.65,29.11-27.43,29.76-47.71,1.94-90.45,22.48-121.48,54.68-30.99,32.24-49.96,75.76-49.97,124.01.02,49.48,19.98,94.01,52.38,126.47,32.46,32.41,77,52.37,126.47,52.38,49.47-.02,94.02-19.97,126.47-52.38,32.4-32.46,52.37-76.99,52.38-126.47,0-3.48-.11-6.94-.3-10.36l-34.09,16.83c-3.7,1.82-8,1.85-11.35.09-3.36-1.79-5.35-5.14-5.26-8.9l3.36-149.83c.11-4.29,2.88-8.36,7.09-10.46,4.24-2.07,9.17-1.81,12.61.74l120.99,88.45c3.05,2.22,4.5,5.83,3.86,9.58-.61,3.76-3.25,7.14-6.97,8.97l-35.72,17.63c1.94,12.17,3.02,24.6,3.02,37.28.01,65.1-26.48,124.31-69.15,166.94-42.64,42.67-101.83,69.16-166.94,69.15-65.1.01-124.3-26.48-166.94-69.15C26.48,360.22-.01,301.01,0,235.91c-.01-63.46,25.16-121.35,65.98-163.7Z',
        fill: '#fff',
        transform: 'translate(6, 3) scale(0.046875)',
      },
      this.svgRoot,
    )
  }
}

Blockly.icons.registry.register(
  new Blockly.icons.IconType(TurnLeft.iconType),
  TurnLeft,
)
Blockly.icons.registry.register(
  new Blockly.icons.IconType(TurnRight.iconType),
  TurnRight,
)
